import { HttpService, isAxiosError } from "./http";

export interface DiaryEntry {
  id?: number;
  client_id?: number;
  clinic_id?: number;
  entry_datetime: string;
  entry_type?: string;
  ate_content?: string;
  noticed_content?: string;
  read_by_practitioner?: boolean;
  practitioner_comment?: string;
  file_id?: number;
  file?: {
    id: number;
    file: string;
    path: string;
    file_path?: string;
  };
  created_at?: string;
  updated_at?: string;
}

class HealthDiaryService extends HttpService {
  public constructor() {
    super("/client-app/health-suite/diary-entries");
  }

  public index(date?: string): Promise<DiaryEntry[]> {
    return this.http
      .get(this.route, {
        params: date ? { date } : {}
      })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  public indexWithEvents(date?: string): Promise<DiaryEntry[]> {
    return this.http
      .get(`${this.route}/events`, {
        params: date ? { date } : {}
      })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  public show(entryId: number): Promise<DiaryEntry> {
    return this.http
      .get(`${this.route}/${entryId}`)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  public create(entry: Omit<DiaryEntry, 'id' | 'read_by_practitioner'> | FormData): Promise<DiaryEntry> {
    return new Promise((resolve, reject) => {
      const config = entry instanceof FormData ? {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      } : {};

      return this.http
        .post(this.route, entry, config)
        .then((response) => {
          this.handleResponse.bind(this);
          resolve(response.data);
        })
        .catch((error) => {
          if (isAxiosError(error) && error.response?.status !== 422) {
            this.handleError.bind(this);
          }
          reject(error);
        });
    });
  }

  public update(entryId: number, entry: Omit<DiaryEntry, 'id' | 'read_by_practitioner'> | FormData): Promise<DiaryEntry> {
    if (entry instanceof FormData) {
      // Use POST for FormData to handle file uploads properly
      entry.append('_method', 'PUT');
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      
      return this.http
        .post(`${this.route}/${entryId}`, entry, config)
        .then(this.handleResponse.bind(this))
        .catch(this.handleError.bind(this));
    } else {
      // Use PUT for regular JSON updates
      return this.http
        .put(`${this.route}/${entryId}`, entry)
        .then(this.handleResponse.bind(this))
        .catch(this.handleError.bind(this));
    }
  }
}

export const healthDiaryService = new HealthDiaryService(); 